import env from 'enviro';
import { FEATURE_STORE_GATE } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);

  if (override !== null && isQA) {
    if (override === 'true') return true;
    return false;
  }

  return !!(gates && gates.indexOf(gateKey) !== -1);
};
export const getIsUngatedForFeatureStore = state => getIsUngated(state, {
  gateKey: FEATURE_STORE_GATE
});
export const getIsUngatedForSeats = state => {
  return getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  }) || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};